import React, { useState } from 'react';
import CheckboxInput from '../checkbox/Checkbox';
import CheckboxInputWarning from '../checkbox/CheckboxWarning';
import Skeleton from "react-loading-skeleton";

const ModalCheckboxWarning = ({ label, checked, setChecked, disabled = false, loading = false }) => {
    return (
        <>

            {loading ?
                <Skeleton height={40} width={150} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
                :
                <div className={`modalsCheckboxWarningWrap ${checked && 'modalsCheckboxWarningActive'}`} onClick={() => !disabled && setChecked(checked)}>
                    <CheckboxInputWarning label={label} checked={checked} setChecked={() => !disabled && setChecked(!checked)} disabled={disabled} />
                </div>
            }
        </>
    )
}

export default ModalCheckboxWarning;

